// ===================================================
// ФАЙЛ: frontend/src/pages/Error/ForbiddenPage.jsx
// ===================================================
import React from 'react';
import MonumentErrorLayout from '../../components/Error/MonumentErrorLayout';

const ForbiddenPage = () => {
  return (
    <MonumentErrorLayout
      status="403"
      title="Нет доступа"
      description="Дверь закрыта. Ключ от этой избы у вас пока другой."
      actionText="В кабинет"
      actionLink="/dashboard"
      bgImageName="403"
    />
  );
};

export default ForbiddenPage;
